import React, { useState } from "react";
import "./SearchField.css";
import searchIcon from "../../assets/search.svg";
import { ReactComponent as BellIcon } from "../../assets/bell.svg";
import Avatar from "../Avatar/Avatar";
import { useNavigate } from "react-router";

const SearchField = ({ isShared = false, onValueChanged = () => {} }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isHovered, setIsHovered] = useState("");

  const handleQueryChanged = (e) => {
    setSearchQuery(e.target.value);
    onValueChanged(e.target.value);
  };

  return (
    <div
      className="search-field-container"
      style={{ marginRight: isShared ? 0 : 32 }}
    >
      <img src={searchIcon} alt="search" className="search-icon" />
      <input
        type="text"
        className="search-field"
        placeholder={"Поиск..."}
        value={searchQuery}
        onChange={handleQueryChanged}
      />
    </div>
  );
};

export default SearchField;
